import type { DatePickerProps } from 'rsuite'

import React, { useCallback } from 'react'

import { DatePicker } from 'rsuite'

import { RSUITE_DATEPICKER_LOCALE } from '@@partner:config/rsuite'

const MILLIS_IN_DAY = 86_400_000 // 60 * 60 * 24 * 1000

/*
  Helper function: filter minutes to show only divideable by 5
*/

const showDividedBy5 = (minute: number) => minute % 5 !== 0

export interface TimePickerProps extends Omit<DatePickerProps, 'onSelect'> {
  onSelect: (seconds: number) => void
}

export default function TimePicker ({ onSelect, ...props }: TimePickerProps) {

  /*
    Because when user inputs hours/minutes date will set today date
    we check date object and normalize if need
  */

  const handleSelect = useCallback(
    (date: Date) => {
      const resultDate = new Date(0, 0, 0, 0, 0, 0, 0)
      const hours = date.getHours()
      const minutes = date.getMinutes()

      const secondsFromStartDay = hours * 3600 + minutes * 60
      // seems that date was changed to today
      if (date.getTime() > MILLIS_IN_DAY) {
        const now = new Date()
        now.setHours(0, 0, 0, 0)
        resultDate.setTime(date.getTime() - now.getTime())
      }
      else {
        resultDate.setTime(date.getTime() - date.getTimezoneOffset() * 60_000)
      }

      onSelect?.(secondsFromStartDay)
      
    },
    [ onSelect ]
  )

  const componentProps = {
    hideMinutes: showDividedBy5,
    format: 'HH:mm',
    locale: RSUITE_DATEPICKER_LOCALE,
    cleanable: false,
    ...props
  }

  return <DatePicker {...componentProps} onSelect={handleSelect} />
}
